import React from 'react';
import { amcTitleCase } from '../../utils';
import amcStyles from '../../styles/amcs.scss';

interface CustomerCareProps {
  amcBasicsDetails: {
    mfBasicsRegistrationCompanyData: {
      addressLine1: string;
      addressLine2: string;
      city: string;
      postalCode: string;
      phone: string;
    }[];
  };
  issuingAuthority: string;
  amcEmail?: string;
}

const CustomerCare: React.FC<CustomerCareProps> = ({
  amcBasicsDetails,
  issuingAuthority,
  amcEmail,
}) => {
  const { mfBasicsRegistrationCompanyData } = amcBasicsDetails;
  const amcBasicDetails = mfBasicsRegistrationCompanyData[0];
  const address = `${amcBasicDetails.addressLine1}, ${amcBasicDetails.addressLine2} ${amcBasicDetails.city} ${amcBasicDetails.postalCode}`;
  const phone = amcBasicDetails.phone;

  return (
    <div className="lil-pt-10 lil-w-full sm:lil-pt-4">
      <h2
        className={`${amcStyles['plan-title']} lil-pt-6 lil-pb-8 sm:lil-pb-4`}
      >
        {amcTitleCase(issuingAuthority)} Customer Care
      </h2>
      <div className="lil-pb-10 sm:lil-pb-6">
        For any query regarding any schemes offered by{' '}
        {amcTitleCase(issuingAuthority)}, please contact at the following
        address:
      </div>
      <div className="lil-w-full lil-flex lil-flex-wrap lil-justify-center lil-gap-20 sm:lil-gap-0">
        {/* Address */}
        <div className="lil-flex-1 lil-pr-10 lil-border-r-sm lil-border-grey-300 sm:lil-border-none sm:lil-pr-0 sm:lil-w-full sm:lil-flex-none sm:lil-pb-8">
          <div className="sm:lil-flex sm:lil-gap-4">
            <img
              src="http://cleartax-media.s3.amazonaws.com/cleartax/images/1742540238_location.svg"
              alt="Location icon"
            />
            <div className="lil-text-s-20 lil-pt-4 lil-pb-4 sm:lil-text-s-18">
              Registered Address
            </div>
          </div>
          <div style={{ color: '#314259B2' }}>{address}</div>
        </div>
        {/* Phone */}
        <div className="lil-flex-1 lil-pr-10 lil-border-r-sm lil-border-grey-300 sm:lil-border-none sm:lil-pr-0 sm:lil-w-full sm:lil-flex-none sm:lil-pb-8">
          <div className="sm:lil-flex sm:lil-gap-4">
            <img
              src="http://cleartax-media.s3.amazonaws.com/cleartax/images/1742540291_calling.svg"
              alt="Phone icon"
            />
            <div className="lil-text-s-20 lil-pt-4 lil-pb-4 sm:lil-text-s-18">
              Contact Number
            </div>
          </div>
          <div style={{ color: '#314259B2' }}>{phone}</div>
        </div>
        {/* Email */}
        <div className="lil-flex-1 sm:lil-w-full sm:lil-flex-none">
          <div className="sm:lil-flex sm:lil-gap-4">
            <img
              src="http://cleartax-media.s3.amazonaws.com/cleartax/images/1742540374_message.svg"
              alt="Email icon"
            />
            <div className="lil-text-s-20 lil-pt-4 lil-pb-4 sm:lil-text-s-18">
              Email
            </div>
          </div>
          <div style={{ color: '#314259B2' }}>
            {amcEmail ? amcEmail : 'Unavailable'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerCare;



// WEBPACK FOOTER //
// ./components/amcNew/CustomerCare.tsx